import { CustomProxyForm } from "common/components/Proxy";
import type { CustomProxy } from "common/types";

import DeleteProxy from "./DeleteProxy";

import type { PROXY_ACTIONS } from "../../constants";

interface ProxyActionsProps {
  proxy: CustomProxy;
  action: keyof typeof PROXY_ACTIONS;
  onClose: () => void;
  onBack: () => void;
}

export default function ProxyActions({
  proxy,
  action,
  onClose,
  onBack,
}: ProxyActionsProps) {
  if (action === "edit") {
    return <CustomProxyForm proxy={proxy} onBack={onBack} />;
  }
  if (action === "delete") {
    return <DeleteProxy proxy={proxy} onBack={onBack} onSuccess={onClose} />;
  }
}
